import { Component, OnInit } from '@angular/core';

@Component({
  template: require('./setores.component.html')
})
export class SetoresComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/estruturas/setores/setores.component.ts
 **/